import { render, staticRenderFns } from "./SnookerSchedule.vue?vue&type=template&id=695e7060&"
import script from "./SnookerSchedule.vue?vue&type=script&lang=js&"
export * from "./SnookerSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SnookerSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports